export const ErrorCodeMap = {
    DEFAULT: '1',
    '100': '100',
    '110': '110',
    '111': '111',
    '112': '112',
    '113': '113',
    '114': '114',
    '120': '110',
    '121': '110',
    '122': '110',
    '123': '110',
    '124': '110',
    '125': '110',
    '200': '110',
    '1000': '1',
    '1100': '1',
    '1101': '3',
    '1102': '2',
    '1103': '2',
    '1104': '2',
    '1105': '1',
    '1106': '1',
    '1200': '5',
    '1201': '5',
    '1202': '1',
    '1203': '1',
    '2000': '1',
    '2100': '1',
    '2200': '1',
    '2300': '1',
    '3001': '4',
    '3002': '4',
    '3003': '4',
    '3004': '4',
    '3100': '4',
    '3101': '4',
    '3102': '4',
    '3103': '4',
    '3104': '4',
    '3200': '4',
    '3201': '4',
    '3202': '4',
    '3203': '4',
    '3204': '4',
    '3300': '4',
    '3301': '4',
    '3302': '4',
    '3303': '4',
    '3304': '4',
    '3400': '4',
    '3401': '4',
    '3402': '4',
    '3403': '4',
    '4000': '1',
    '4100': '1',
    '4101': '1',
    '4200': '1',
    '4201': '1',
    '4300': '5',
    '9999': '4'
};
